
import { useState } from "react";
import NewComment from "./NewComment";
import deleteIcon from '../images/icon-delete.svg'
import editIcon from '../images/icon-edit.svg'
import minusIcon from '../images/icon-minus.svg'
import plusIcon from '../images/icon-plus.svg'
import replyIcon from '../images/icon-reply.svg'


export default function Reply(props) {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const isCurrentUser = props.user.username === props.currentUser.username;
  const isReplying =
    props.activeComment &&
    props.activeComment.id === props.id &&
    props.activeComment.type === "replying";
  const isEditing =
    props.activeComment &&
    props.activeComment.id === props.id &&
    props.activeComment.type === "editing";

  return (
    <div>
      <div className="comment">
        <div className="comment-heading">
          <img
            className="user-avatar"
            src={props.user.image.png}
            alt="user avatar"
          />
          <p className="username">{props.user.username}</p>
          {props.user.username === props.currentUser.username && (
            <p className="tag">Eu</p>
          )}
          <p className="date">{props.createdAt}</p>
          <div className="comment-footer">
            {isCurrentUser ? (
              <div className="toggled-btns">
                <button
                  className="edit-btn"
                  onClick={() => {
                    props.setActiveComment({ id: props.id, type: "editing" });
                  }}
                >
                  <img
                    className="edit-icon"
                    src={editIcon}
                    alt="edit icon"
                  />
                  Editar
                </button>
                <button
                  className="delete-btn"
                  onClick={() => {
                    setShowDeleteModal(true);
                  }}
                >
                  <img
                    className="delete-icon"
                    src={deleteIcon}
                    alt="delete icon"
                  />
                  Deletar
                </button>
              </div>
            ) : (
              <button
                className="reply-btn"
                onClick={() =>
                  props.setActiveComment({ id: props.id, type: "replying" })
                }
              >
                <img
                  className="reply-icon"
                  src={replyIcon}
                  alt="reply icon"
                />
                Comentar
              </button>
            )}
          </div>
        </div>
        <div className="editing">

          {!isEditing && <p className="comment-content">{props.content}</p>}
          {isEditing && (
            <NewComment
              currentUser={props.currentUser}
              handleSubmit={(text) => {
                props.updateReply(text, props.id);
              }}
              initialText={props.content}
              isEdit
              buttonText='Atualizar'
            />
          )}
        </div>
      </div>

      {isReplying && (
        <div>
          <NewComment
            currentUser={props.currentUser}
            placeholder={`Respondendo para @${props.user.username}`}
            handleSubmit={(text) =>
              props.addReply(`@${props.user.username}, ${text}`)
            }
            buttonText='Enviar'
          />
        </div>
      )}

      {showDeleteModal && (
        <div className="delete-modal-container">
          <div className="delete-modal">
            <h2 className="delete-modal_title">Deletar comentário</h2>
            <p className="delete-modal_content">
              Você tem certeza que deseja deletar este comentário? Ele será removido
              e não poderá ser desfeito.
            </p>
            <div className="delete-modal_btns">
              <button
                className="delete-modal_btn no"
                onClick={() => {
                  setShowDeleteModal(false);
                }}
              >
                Não, cancelar
              </button>
              <button
                className="delete-modal_btn yes"
                onClick={() => {
                  props.deleteReply(props.id);
                }}
              >
                Sim, deletar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
